import { Download, Paperclip } from "lucide-react";

import RichTextEditor from "../../../components/RichTextEditor";
import { Button } from "../../../components/ui/button";
import { MAX_TICKET_ATTACHMENTS } from "../constants";
import { formatDate, formatOptionalDate } from "../formatters";

export default function TicketConversation({
  loading,
  messageDraft,
  messageFiles,
  messages,
  onDownload,
  onFilesChange,
  onMessageChange,
  onSubmit,
  userRole,
}) {
  return (
    <div className="support-ticket-panel">
      <h3 className="heading-3">Conversation</h3>
      {messages.map((message) => (
        <div key={message.id} className="support-message">
          <div className="support-message-head">
            <strong>{message.author_name}</strong>
            <small>{formatDate(message.created_at)}</small>
          </div>
          <div
            className="support-rich-content"
            dangerouslySetInnerHTML={{ __html: message.content }}
          />
          {message.attachments?.length > 0 && (
            <div className="support-message-attachments">
              {message.attachments.map((attachment) => (
                <button
                  key={attachment.id}
                  type="button"
                  className="support-message-attachment"
                  onClick={() => onDownload(attachment)}
                >
                  <Paperclip aria-hidden="true" />
                  <span>
                    <strong>{attachment.filename}</strong>
                    <small>{(attachment.size / 1024).toFixed(1)} Ko</small>
                  </span>
                  <Download aria-hidden="true" />
                </button>
              ))}
            </div>
          )}
          {userRole !== "client" && message.author_role !== "client" && (
            <small className="support-message-read">
              Vu par le client : {formatOptionalDate(message.seen_by_client_at)}
            </small>
          )}
          {userRole === "client" && message.author_role === "client" && (
            <small className="support-message-read">
              Vu par le support : {formatOptionalDate(message.seen_by_admin_at || message.seen_by_developer_at)}
            </small>
          )}
        </div>
      ))}
      {userRole === "client" && (
        <form onSubmit={onSubmit} className="support-form-stack">
          <RichTextEditor
            value={messageDraft}
            onChange={onMessageChange}
            placeholder="Ajouter une reponse, une liste ou un bloc code"
            minHeight={160}
          />
          <label className="support-message-file-picker">
            <Paperclip aria-hidden="true" />
        <span>Ajouter des pièces jointes</span>
            <input
              key={messageFiles.length}
              type="file"
              multiple
              accept=".pdf,.png,.jpg,.jpeg,.docx"
              onChange={onFilesChange}
            />
          </label>
          <div className="support-message-file-summary">
            <span>
              {messageFiles.length > 0
                ? `${messageFiles.length} fichier(s) selectionne(s)`
                : `Jusqu'a ${MAX_TICKET_ATTACHMENTS} fichiers, 5 Mo maximum par fichier`}
            </span>
            {messageFiles.map((file) => (
              <small key={`${file.name}-${file.size}`}>{file.name}</small>
            ))}
          </div>
          <Button type="submit" className="btn-secondary" disabled={loading}>Envoyer le message</Button>
        </form>
      )}
    </div>
  );
}
